import { Button, message, Popconfirm, Table } from 'antd';
import React, { useEffect } from 'react';
import { RootState } from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { deleteAllNewsletters, deleteNewsletter, listNewsletters } from '../../../redux/actions/newsletter';
import ProtectedLayout from '../../../layouts/ProtectedLayout';
import { DeleteOutlined } from '@ant-design/icons';
import ExportExcel from '../Shared/ExportExcel';
import { columnMappings } from '../Shared/utility';

const NewsletterPage: React.FC = () => {
    const { newsletters, loading } = useSelector((state: RootState) => state.newsletter);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(listNewsletters());
    }, [dispatch]);

    const handleDelete = async (id: string) => {
        try {
            await dispatch(deleteNewsletter(id));
            message.success('E-bülten kaydı başarıyla silindi');
        } catch (error) {
            message.error('Silme işlemi sırasında bir hata oluştu');
        }
    };

    const handleDeleteAll = async () => {
        try {
            await dispatch(deleteAllNewsletters());
            message.success('Tüm e-bülten kayıtları başarıyla silindi');
        } catch (error) {
            message.error('Silme işlemi sırasında bir hata oluştu');
        }
    };

    const columns = [
        {
            title: 'Email',
            dataIndex: 'email',
        },
        {
            title: 'İşlem Zamanı',
            dataIndex: 'createdAt',
            render: (text) => {
                return new Date(text).toLocaleString('tr-TR', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                });
            }
        },
        {
            title: 'İşlemler',
            key: 'actions',
            width: 100,
            render: (_, record) => (
                <Popconfirm title={`${record.email} Kaydı Silinecektir?`} onConfirm={() => handleDelete(record._id)} cancelText="İptal" okText="Evet">
                    <Button
                        danger
                        icon={<DeleteOutlined />}
                    >
                        Sil
                    </Button>
                </Popconfirm>
            ),
        },
    ];
    return (
        <ProtectedLayout>
            <h1 className="text-2xl font-bold">E-Bülten Listesi</h1>
            <div className="space-y-4">
                <div className="flex justify-end">
                    <ExportExcel excelData={newsletters} fileName={"E-Bülten Listesi"} columnMappings={columnMappings(columns)} />
                    <Button
                        danger
                        onClick={handleDeleteAll}
                        disabled={!newsletters?.length}
                    >
                        Tümünü Sil
                    </Button>
                </div>
                <Table
                    dataSource={newsletters || []}
                    columns={columns}
                    loading={loading}
                />
            </div>
        </ProtectedLayout>
    );
};

export default NewsletterPage;